import type { OpenAPI } from "simplydo/interfaces";
import type { UserProfilePrepared } from "simplydo/interfaces/types/userTypes";

export type PublicUser = OpenAPI.GET<"/users/{id}">["response"];

export type UserProfile = NonNullable<OpenAPI.Schemas["User"]["profile"]>;

/** Partial profile fields passed from settings form handlers (includes runtime URL fields). */
export type ProfileUpdate = Partial<UserProfilePrepared> &
  OpenAPI.Schemas["AssignUserProfileCoverImageUrl"] &
  OpenAPI.Schemas["AssignUserProfileCoverImageThumbnails"] &
  OpenAPI.Schemas["AssignUserProfileVideo"] &
  OpenAPI.Schemas["AssignUserProfileVideoUrl"] & {
    coverImageThumbnailUrls?: Record<string, string> | null;
  };

export type ProfileUpload = NonNullable<
  UserProfilePrepared["uploads"]
>[number] & { url?: string };

export type UserIdeaOptions = {
  filter: string;
  showDraft: boolean;
  showSubmitted: boolean;
  sort: string;
};

export type CustomAchievementListItem = NonNullable<
  PublicUser["customAchievements"]
>[number];

/** Runtime following item (OpenAPI following schema is incomplete). */
export type FollowingItem = {
  _id: string;
  type: "challenge" | "idea";
  createdAt: string;
  reason?: string;
  reasonText?: string;
  unfollowed?: boolean;
  isDeleted?: boolean;
  ownerChallenge?: { name?: string; bannerImageUrl?: string };
  ownerIdea?: OpenAPI.Schemas["Idea"];
};

export type SocialMediaKey =
  | "facebook"
  | "twitter"
  | "linkedin"
  | "instagram"
  | "github";

type FollowingApiItem =
  OpenAPI.GET<"/users/{id}/following">["response"]["following"][number];

export function parseFollowingItem(item: FollowingApiItem): FollowingItem {
  const row = item as {
    _id?: string;
    type?: string;
    createdAt?: string;
    reason?: string;
    reasonText?: string;
    unfollowed?: boolean;
    isDeleted?: boolean;
    ownerChallenge?: FollowingItem["ownerChallenge"];
    ownerIdea?: FollowingItem["ownerIdea"];
  };

  return {
    _id: row._id ?? "",
    type: row.type === "challenge" ? "challenge" : "idea",
    createdAt: row.createdAt ?? "",
    reason: row.reason,
    reasonText: row.reasonText,
    unfollowed: row.unfollowed,
    isDeleted: row.isDeleted,
    ownerChallenge: row.ownerChallenge,
    ownerIdea: row.ownerIdea,
  };
}
